import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotfoundComponent } from './demo/components/notfound/notfound.component';
import { AppLayoutComponent } from "./layout/app.layout.component";
import { AuthGuard } from './@core/Guards/auth.guard';
import { MsalGuard } from '@azure/msal-angular';
import { ConditionalMsalGuard } from './@core/Guards/conditional-msal.guard';
const routes: Routes = [
    { path: '', redirectTo: 'auth', pathMatch: 'full' },
    {
        path: 'auth', loadChildren: () => import('src/app/modules/auth/auth.module').then(m => m.AuthModule),
    },
    // {
    //     path: 'app',
    //     canActivate: [AuthGuard],
    //     loadChildren: () => import('./modules/layouts/layout.module').then(m => m.LayoutModule)
    // },
    // { path: 'dashboard', loadChildren: () => import('../app/modules/dashboard/user-dashboard.module').then(m => m.UserDashboardModule) },

    {
        path: 'app', canActivate: [ConditionalMsalGuard], loadChildren: () => import('src/app/modules/layouts/layout-admin/layout-admin.module').then(m => m.LayoutAdminModule),
    },
    {
        path: 'user', canActivate: [ConditionalMsalGuard], loadChildren: () => import('src/app/modules/layouts/layout-user/layout-user.module').then(m => m.LayoutUserModule),
    },
    // { path: 'user', loadChildren: () => import('./layout-user/user-layout/user-layout.module').then(m => m.UserLayoutModule) },
    // {
    //     path: '', component: AppLayoutComponent,
    //     children: [
    //         { path: '', loadChildren: () => import('./demo/components/dashboard/dashboard.module').then(m => m.DashboardModule) },
    //         { path: 'uikit', loadChildren: () => import('./demo/components/uikit/uikit.module').then(m => m.UIkitModule) },
    //         { path: 'utilities', loadChildren: () => import('./demo/components/utilities/utilities.module').then(m => m.UtilitiesModule) },
    //         { path: 'documentation', loadChildren: () => import('./demo/components/documentation/documentation.module').then(m => m.DocumentationModule) },
    //         { path: 'blocks', loadChildren: () => import('./demo/components/primeblocks/primeblocks.module').then(m => m.PrimeBlocksModule) },
    //         { path: 'pages', loadChildren: () => import('./demo/components/pages/pages.module').then(m => m.PagesModule) }
    //     ]
    // },
    // { path: 'auth', loadChildren: () => import('./demo/components/auth/auth.module').then(m => m.AuthModule) },
    // { path: 'landing', loadChildren: () => import('./demo/components/landing/landing.module').then(m => m.LandingModule) },
    // { path: 'notfound', component: NotfoundComponent },
    // { path: '**', redirectTo: '/notfound' },
]
@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }

// { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' }
